export enum RsvpPageType {
   AgeGate = 1,
   GeoLocationLookup = 2,
   ZipCodeLookup = 3,
   EventSelect = 4,
   Registration = 5,
   GuestInvite = 6,
   FriendInvite = 7,
   Confirmation = 8
}

export const registerStep = {
   fields: [
      { // subtitle text
         key: '0',
         type: 'textLabel',
         required: false,
         sizeX: 2,
         sizeY: 2,
         minSizeX: 0,
         minSizeY: 2,
         row: 0,
         col: 0,
         description: {}
      },
      {
         key: '1',
         type: 'eventDetails',
         required: false,
         sizeX: 2,
         sizeY: 6,
         minSizeX: 0,
         minSizeY: 6,
         row: 2,
         col: 0
      },
      { // 'your details' text
         key: '2',
         type: 'textLabel',
         required: false,
         sizeX: 2,
         sizeY: 2,
         minSizeX: 0,
         minSizeY: 2,
         row: 8,
         col: 0,
         description: {}
      },
      {
         key: 'firstName',
         label: {},
         type: 'text',
         required: true,
         sizeX: 2,
         sizeY: 3,
         minSizeX: 0,
         minSizeY: 3,
         row: 10,
         col: 0
      },
      {
         key: 'lastName',
         label: {},
         type: 'text',
         required: true,
         sizeX: 2,
         sizeY: 3,
         minSizeX: 0,
         minSizeY: 3,
         row: 13,
         col: 0
      },
      {
         key: 'email',
         label: {},
         type: 'text',
         required: true,
         sizeX: 2,
         sizeY: 3,
         minSizeX: 0,
         minSizeY: 3,
         row: 16,
         col: 0
      },
      {
         key: 'zip',
         label: {},
         type: 'text',
         required: false,
         sizeX: 2,
         sizeY: 3,
         minSizeX: 0,
         minSizeY: 3,
         row: 19,
         col: 0
      }
   ]
};